import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {ReactComponent as CounterIco} from "../../../../../../images/icons/counter.svg";
import {ReactComponent as BarcodeIco} from "../../../../../../images/icons/barcode.svg";
import {ReactComponent as TableIco} from "../../../../../../images/icons/table.svg";
import {ReactComponent as EditIco} from "../../../../../../images/icons/edit.svg";
import {ConfigApi, DineInType, OrderType} from "../../../../../services/Api/types";
import CartChangeOrderDetailsScanModal from "../CartChangeOrderDetailsScanModal";
import {createKeyDownHandler} from "../../../../../utils/keyDownHanlder";
import StoreUtils from "../../../../../services/Store/StoreUtils";

interface Props {
    config: ConfigApi | undefined;
    current: DineInType | undefined;
    setDineInOption: React.Dispatch<DineInType>;
    currentType: OrderType | "";
    table: string | undefined;
    setTable: React.Dispatch<string>;
}

const CartChangeOrderDetailsDineInOptionsModal = ({
                                                      config,
                                                      current,
                                                      setDineInOption,
                                                      currentType,
                                                      table,
                                                      setTable
                                                  }: Props) => {
    const {t} = useTranslation();
    const [showScanModal, setShowScanModal] = useState(false);
    const options: DineInType[] = StoreUtils.getDineInTypes(config);

    const isOptionVisible = (option: DineInType) => {
        if (options.length === 0) return false;

        if (!options.includes(option)) return false;

        if (options.length === 1) {
            return option !== DineInType.COUNTER;
        }

        return options.includes(option);
    }

    const isCounterOptionVisible = isOptionVisible(DineInType.COUNTER);
    const isTableOptionVisible = isOptionVisible(DineInType.TABLE);

    if (currentType !== OrderType.DINE_IN || (!isTableOptionVisible && !isCounterOptionVisible)) return <></>;

    const onTableOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDineInOption(event.target.value as DineInType)
        setShowScanModal(true);
    }

    const onCounterOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDineInOption(event.target.value as DineInType);
        setTable("");
    }

    const handleOnLabelKeyDown = (type: DineInType.COUNTER | DineInType.TABLE) => createKeyDownHandler<HTMLLabelElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        action: () => {
            setDineInOption(type);
            if (type === DineInType.COUNTER) {
                setTable("");
            } else {
                setShowScanModal(true);
            }
        }
    });

    return (
        <div className="mt-4 d-flex flex-column gap-2">
            <h1 className="h5 mb-2">{t("modules.cart.field.pickup_location.title")}</h1>
            {
                isCounterOptionVisible && (
                    <label tabIndex={0} aria-checked={current === DineInType.COUNTER}
                           onKeyDown={handleOnLabelKeyDown(DineInType.COUNTER)}
                           className={`btn btn-default btn-lg btn-check-full ${current === DineInType.COUNTER ? " active" : ""}`}>
                        <CounterIco/>
                        <span>{t("enums.dine_in.type.COUNTER")}</span>
                        <input className="btn-check1" type="radio" name="dine_in_type" value={DineInType.COUNTER}
                               autoComplete="off"
                               tabIndex={-1}
                               checked={current === DineInType.COUNTER}
                               onChange={onCounterOptionChange}/>
                    </label>
                )
            }
            {
                isTableOptionVisible && (
                    <label tabIndex={0} aria-checked={current === DineInType.TABLE}
                           onKeyDown={handleOnLabelKeyDown(DineInType.TABLE)}
                           className={`btn btn-default btn-lg btn-check-full ${current === DineInType.TABLE ? " active" : ""}`}>
                        <TableIco/>
                        <span>
                            <p className="mb-0">{t("enums.dine_in.type.TABLE")}</p>
                            <small className={`${table ? " text-primary" : "text-muted"}`}>
                                {!table ? t("modules.cart.action.scan_table_qr_code.title") : table}
                            </small>
                        </span>
                        <input style={{width: current === DineInType.TABLE ? 0 : "unset"}} className="btn-check1"
                               type="radio"
                               name="dine_in_type" value={DineInType.TABLE}
                               autoComplete="off"
                               tabIndex={-1}
                               checked={current === DineInType.TABLE}
                               onClick={() => setShowScanModal(true)}
                               onChange={onTableOptionChange}/>
                        {
                            current === DineInType.TABLE && !table && (
                                <BarcodeIco className="text-primary mx-0"/>
                            )
                        }
                        {
                            current === DineInType.TABLE && table && (
                                <EditIco className="text-primary mx-0"/>
                            )
                        }
                    </label>
                )
            }
            {
                showScanModal &&
                <CartChangeOrderDetailsScanModal show={showScanModal} onHide={() => setShowScanModal(false)}
                                                 currentType={currentType}
                                                 type={OrderType.DINE_IN} handleSave={setTable} config={config}/>
            }
        </div>
    )
}

export default CartChangeOrderDetailsDineInOptionsModal;